import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { VM } from '@hetao/scratch-core';
import H5IframeModal from '../components/h5-iframe-modal/h5-iframe-modal.jsx';

class H5IframeModalContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleOpenUrl = this.handleOpenUrl.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            visible: false,
            url: ''
        };
    }

    componentDidMount() {
        this.props.vm.runtime.on('OPEN_URL', this.handleOpenUrl);
    }

    componentWillUnmount() {
        this.props.vm.runtime.off('OPEN_URL', this.handleOpenUrl);
    }

    handleOpenUrl({ url, newWindow }) {
        if (newWindow) {
            window.open(url, '_blank');
        } else {
            this.setState({
                visible: true,
                url: url || ''
            });
        }
    }

    handleClose() {
        this.setState({
            visible: false,
            url: ''
        });
        if (this.props.onScratchChapterPassed) {
            this.props.onScratchChapterPassed();
        }
    }

    render() {
        if (this.state.visible) {
            return (
                <H5IframeModal
                    key={this.state.url}
                    url={this.state.url}
                    onClose={this.handleClose}
                />
            );
        }
        return null;
    }
}

H5IframeModalContainer.propTypes = {
    vm: PropTypes.instanceOf(VM).isRequired,
    onScratchChapterPassed: PropTypes.func
};

const mapStateToProps = (state) => ({
    vm: state.scratchGui.vm
});

export default connect(mapStateToProps)(H5IframeModalContainer);
